/* eslint-disable no-multi-assign */
/* eslint-disable no-shadow */
import { http } from "@/api/index";
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import i18n from "@/i18n";
import { GetErrorMessage } from "@/constants/errors-http/HTTPHandler";
import {
	OPEN_DIALOG_TREND_PARK,
	CLOSE_DIALOG_TREND_PARK,
	GET_PARK_TREND_SIGNALS,
	GET_PARK_TREND_SIGNALS_SUCCESS,
	GET_PARK_TREND_SIGNALS_ERROR,
	GET_PARK_TREND_SIGNALS_RECORDS,
	GET_PARK_TREND_SIGNALS_RECORDS_SUCCESS,
	GET_PARK_TREND_SIGNALS_RECORDS_ERROR,
	GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED,
	GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED_SUCCESS,
	GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED_ERROR,
	CLOSE_SNACK_BAR,
	TRIGGER_SNACK_BAR,
} from "@/stores/actions/TrendPark";

const state = {
	dialog:               false,
	availableSignals:     [],
	selectedTrendSignals: [],
	selectedBaseSignal:   "",
	selectedPeriod:       i18n.t("PeriodSelector.Last7Days"),
	recordsData:          [],
	signalsData:          [],
	statusSignals:        FetchStatus.Init,
	statusRecords:        FetchStatus.Init,
	error:                {},
	errorHead:            "",
	snackbar:             false,
	errorText:            "",
};
const Qs = require("qs");

const actions = {
	/**
	 * @summary Dispara o commit para abrir o dialogo do gráfico de sinais de tendência na página do park.
	 * @type {void}
	 */
	[OPEN_DIALOG_TREND_PARK]: ({ commit }) =>
	{
		commit(OPEN_DIALOG_TREND_PARK);
		state.dialog = true;
	},

	/**
	 * @summary Dispara o commit para fechar o dialogo do gráfico de sinais de tendência na página do park.
	 * @type {void}
	 */
	 [CLOSE_DIALOG_TREND_PARK]: ({ commit }) =>
	 {
		 state.statusSignals = FetchStatus.Init;
		 state.statusRecords = FetchStatus.Init;
		 state.recordsData = [];
		 state.signalsData = [];
		 state.dialog = false;
		 state.availableSignals = [];
		 state.selectedTrendSignals = [];
		 state.selectedPeriod = i18n.t("PeriodSelector.Last7Days");
		 commit(CLOSE_DIALOG_TREND_PARK);
	 },

	 /**
	 * @summary Dispara o commit para abrir o snackbar de erro.
	 * @type {void}
	 */
	[TRIGGER_SNACK_BAR]: ({ commit }) =>
	{
		commit(TRIGGER_SNACK_BAR);
	},

	/**
	 * @summary Dispara o commit para fechar a snackbar de erro 404 de tendência.
	 * @type {void}
	 */
	[CLOSE_SNACK_BAR]: ({ commit }) =>
	{
		commit(CLOSE_SNACK_BAR);
	},

	/**
	 * @summary Realiza a requisição http no back-end dos sinais de tendência.
	 * @type {void}
	 * @param {Object} parameters Array com os monitoringElementsIds das turbinas do parque selecionado.
	 */
	[GET_PARK_TREND_SIGNALS]: ({ commit }, parameters) =>
	{
		commit(GET_PARK_TREND_SIGNALS);

		http.get("/TrendSignalSettings/Park",
			{
				params:           parameters,
				paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" }),
			})
			.then((resp) =>
			{
				if (resp.status !== 200)
				{
					commit(GET_PARK_TREND_SIGNALS_ERROR, resp.status);
				}
				else
				{
					commit(GET_PARK_TREND_SIGNALS_SUCCESS, resp);
				}
			})
			.catch((error) =>
			{
				commit(GET_PARK_TREND_SIGNALS_ERROR, error.response.status);
			});
	},

	/**
	 * @summary Realiza a requisição http no back-end dos valores dos sinais de tendência selecionados.
	 * @type {void}
	 * @param {Object} parameters Objeto com os trendSettingsIds, data de inicio da pesquisa e data final da pesquisa.
	 */
	[GET_PARK_TREND_SIGNALS_RECORDS]: ({ commit }, parameters) =>
	{
		commit(GET_PARK_TREND_SIGNALS_RECORDS);

		http.get("/TrendSignalRecords",
			{
				params:           parameters,
				headers:          { dateTimeFormat: "dd/MM/yyyy HH:mm:ss" },
				paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" }),
			})
			.then((resp) =>
			{
				if (resp.status !== 200)
				{
					commit(GET_PARK_TREND_SIGNALS_RECORDS_ERROR, resp.status);
				}
				else
				{
					commit(GET_PARK_TREND_SIGNALS_RECORDS_SUCCESS, resp);
				}
			})
			.catch((error) =>
			{
				commit(GET_PARK_TREND_SIGNALS_RECORDS_ERROR, error.response);
			});
	},

	/**
	 * @summary Realiza a requisição http no back-end dos valores dos sinais de tendência selecionados com estratificação.
	 * @type {void}
	 * @param {Object} parameters Objeto com os trendSettingsIds, data de inicio da pesquisa e data final da
	 * pesquisa e estratificação.
	 */
	 [GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED]: ({ commit }, parameters) =>
	 {
		 commit(GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED);

		 http.get("/TrendSignalRecords/Stratification",
			 {
				 params:           parameters,
				 headers:          { dateTimeFormat: "dd/MM/yyyy HH:mm:ss" },
				 paramsSerializer: params => Qs.stringify(params, { allowDots: true, arrayFormat: "indices" }),
			 })
			 .then((resp) =>
			 {
				if (resp.status !== 200)
				{
					commit(GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED_ERROR, resp.status);
				}
				else
				{
					commit(GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED_SUCCESS, resp);
				}
			 })
			 .catch((error) =>
			 {
				 commit(GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED_ERROR, error.response.status);
			 });
	 },
};

const mutations = {
	[OPEN_DIALOG_TREND_PARK]: (state) =>
	{
		state.dialog = true;
	},
	[CLOSE_DIALOG_TREND_PARK]: (state) =>
	{
		state.dialog = false;
	},
	[GET_PARK_TREND_SIGNALS]: (state) =>
	{
		state.statusSignals = FetchStatus.Loading;
	},
	[GET_PARK_TREND_SIGNALS_SUCCESS]: (state, resp) =>
	{
		state.signalsData = resp.data;
		state.availableSignals = resp.data[0].signalsSettings;
		state.statusSignals = FetchStatus.Loaded;
	},
	[GET_PARK_TREND_SIGNALS_ERROR]: (state, error) =>
	{
		state.error = error;
		state.errorText = GetErrorMessage(error);
		state.statusSignals = FetchStatus.Error;
		state.snackbar = true;
	},
	[GET_PARK_TREND_SIGNALS_RECORDS]: (state) =>
	{
		state.statusRecords = FetchStatus.Loading;
	},
	[GET_PARK_TREND_SIGNALS_RECORDS_SUCCESS]: (state, resp) =>
	{
		state.recordsData = resp.data;
		state.statusRecords = FetchStatus.Loaded;
	},
	[GET_PARK_TREND_SIGNALS_RECORDS_ERROR]: (state, error) =>
	{
		state.error = error;
		state.errorText = GetErrorMessage(error);
		state.statusRecords = FetchStatus.Error;
		state.snackbar = true;
	},
	[GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED]: (state) =>
	{
		state.statusRecords = FetchStatus.Loading;
	},
	[GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED_SUCCESS]: (state, resp) =>
	{
		state.recordsData = resp.data;
		state.statusRecords = FetchStatus.Loaded;
	},
	[GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED_ERROR]: (state, error) =>
	{
		state.error = error;
		state.errorText = GetErrorMessage(error);
		state.statusRecords = FetchStatus.Error;
		state.snackbar = true;
	},
	[TRIGGER_SNACK_BAR]: (state) =>
	{
		state.snackbar = true;
		state.errorText = i18n.t("ErrorMessages.InvalidConfigurationMessage", i18n.locale);
	},
	[CLOSE_SNACK_BAR]: (state) =>
	{
		state.snackbar = false;
		state.dialog = false;
	},
};

export default {
	state,
	actions,
	mutations,
};
